import {Box, Grid, Stack, Typography} from '@mui/material'
import {getMerchantAddressextAPI} from '../../helpers/UtilityHelper'

import {useForm} from 'react-hook-form'
import {FormProvider, RHFCheckbox} from '../../common/hook-form'
import {useSnackbar} from 'notistack'
import {apiConstants, postGeneric} from '../../common/constants'
import {yupResolver} from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import {Link, useNavigate} from 'react-router-dom'

import {
  DividerText,
  ForgotPasswordButton,
  HeaderContainer,
  IconContainer,
  StyledDivider,
  StyledIcon,
  StyledLoadingButton,
  StyledPincodeField,
  StyledTextField,
  SubTitle,
  WelcomeTitle,
} from './StyledElements'
import {
  Business,
  Email,
  LocationCity,
  LocationOn,
  Phone,
  Save,
  Streetview,
} from '@mui/icons-material'

export default function Login() {
  const {enqueueSnackbar} = useSnackbar()
  const navigate = useNavigate()

  const phoneRegExp = /^\d{10}$/

  const method = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        name: Yup.string().required('Name is required'),
        email: Yup.string().required('Email address is required'),
        contact_no: Yup.string()
          .matches(phoneRegExp, {
            message: 'Phone Number must be exactly 10 digits',
            excludeEmptyString: true,
          })
          .min(10, 'Phone Number must be at least 10 digits')
          .required('Phone Number is required!'),

        address: Yup.string().required('Address is required'),
        pincode: Yup.string()
          .test('valid-pincode', 'Invalid pincode', (value) => {
            if (!value) {
              return false // Empty value
            }

            const regex = /^\d{6}$/ // 6-digit number
            return regex.test(value) || value.length !== 6
          })
          .required('Pincode is a mandatory field')
          .test('length', 'Please enter a 6 digit pincode', (value) => {
            return !value || value.length === 6
          })
          .test('valid', 'Please enter a valid pincode', (value) => {
            if (!value || value.length !== 6) {
              return true // Skip validation for non-6 digit values
            }

            const regex = /^\d{6}$/ // 6-digit number
            return regex.test(value)
          }),
        city: Yup.string().required('City is required'),
        state: Yup.string().required('State is required'),
        country: Yup.string().required('Country is required'),
        toc: Yup.bool()
          .oneOf([true], 'Please accept the terms & conditions')
          .required('Please accept the terms & conditions'),
      })
    ),
    defaultValues: {
      name: '',
      email: '',
      contact_no: '',
      address: '',
      pincode: '',
      city: '',
      state: '',
      companyName: '',
      country: 'India',
    },
  })


  const {handleSubmit, setValue, watch} = method

  const onSubmit = (data) => {
    // navigate("/otp")
    postGeneric(apiConstants.SIGNUP, data)
      .then((response) => {
        enqueueSnackbar('OTP Sent! Please check your mobile number for otp credentials', {
          variant: 'success',
        })
        navigate('/otp?type=signup', {state: response.data})
      })
      .catch((error) => {
        enqueueSnackbar(error?.response?.data?.message || 'Oops Something went wrong!', {
          variant: 'error',
        })
      })
  }

  const watchPincode = watch('pincode')
  const fetchAddresses = async () => {
    const merchantAddress = await getMerchantAddressextAPI(watchPincode)
    return merchantAddress
  }
  const handleAddressSelect = (address) => {
    setValue('city', address.city)
    setValue('state', address.state)
    setValue('pincode', address.pincode)
  }

  return (
    <Box>
      <HeaderContainer>
        <WelcomeTitle variant='h4'>Sign Up</WelcomeTitle>
        <SubTitle variant='body1' color='text.secondary'>
          Please provide your details below to sign up
        </SubTitle>
      </HeaderContainer>
      <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <StyledTextField
              // name='name'
              name='companyName'
              mandatory='true'
              label='Business Name'
              placeholder='Please enter your registered business name as per GST document'
              variant='outlined'
              size='medium'
              InputProps={{
                startAdornment: (
                  <IconContainer>
                    <StyledIcon>
                      <Business />
                    </StyledIcon>
                  </IconContainer>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <StyledTextField
              name='email'
              mandatory='true'
              label='Email'
              placeholder='Please enter your email address'
              variant='outlined'
              size='medium'
              InputProps={{
                startAdornment: (
                  <IconContainer>
                    <StyledIcon>
                      <Email />
                    </StyledIcon>
                  </IconContainer>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <StyledTextField
              mandatory='true'
              name='contact_no'
              label='Contact Number'
              placeholder='Please enter your  contact number'
              variant='outlined'
              size='medium'
              InputProps={{
                startAdornment: (
                  <IconContainer>
                    <StyledIcon>
                      <Phone />
                    </StyledIcon>
                  </IconContainer>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <StyledTextField
              name='address'
              mandatory='true'
              label='Billing/Registered Address'
              placeholder='Please enter your billing/registered address'
              variant='outlined'
              size='medium'
              InputProps={{
                startAdornment: (
                  <IconContainer>
                    <StyledIcon>
                      <LocationOn />
                    </StyledIcon>
                  </IconContainer>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <StyledTextField
              // name='companyName'
              name='name'
              label='Brand Name'
              placeholder='Please enter your brand name'
              variant='outlined'
              size='medium'
              InputProps={{
                startAdornment: (
                  <IconContainer>
                    <StyledIcon>
                      <Business />
                    </StyledIcon>
                  </IconContainer>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <StyledPincodeField
              variant='outlined'
              name='pincode'
              label='Enter Pincode'
              placeholder='Please enter your pincode'
              fetchAddresses={fetchAddresses}
              onAddressSelect={handleAddressSelect}
              size='medium'
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <StyledTextField
              name='city'
              mandatory='true'
              label='City'
              placeholder='Please enter your city'
              variant='outlined'
              size='medium'
              InputProps={{
                startAdornment: (
                  <IconContainer>
                    <StyledIcon>
                      <LocationCity />
                    </StyledIcon>
                  </IconContainer>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <StyledTextField
              name='state'
              label='State'
              placeholder='Please enter your state'
              variant='outlined'
              size='medium'
              InputProps={{
                startAdornment: (
                  <IconContainer>
                    <StyledIcon>
                      <Streetview />
                    </StyledIcon>
                  </IconContainer>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <RHFCheckbox
              sx={{
                '& .MuiCheckbox-root, & .MuiFormControlLabel-label': {
                  color: '#000 !important',
                  '& a': {
                    color: '#000 !important',
                  },
                },
              }}
              name='toc'
              label={
                <>
                  I have read and agree to the{' '}
                  <Link to='/toc' target='_blank'>
                    <u>Terms & Conditions</u>
                  </Link>
                </>
              }
            />
            {method?.formState?.errors?.toc && (
              <Typography variant='caption' color='#fff'>
                {`${method?.formState?.errors?.toc?.message}`}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} md={12}>
            <Stack spacing={2}>
              <StyledLoadingButton
                fullWidth
                type='submit'
                variant='contained'
                size='large'
                disabled={!method.formState.isValid}
                startIcon={<Save />}
              >
                Submit
              </StyledLoadingButton>
              <StyledDivider>
                <DividerText variant='body2' color='text.secondary'>
                  OR
                </DividerText>
              </StyledDivider>
              <ForgotPasswordButton variant='text' component={Link} to='/login'>
                Back to Login
              </ForgotPasswordButton>
            </Stack>
          </Grid>
        </Grid>
      </FormProvider>
    </Box>
  )
}
